<template>
  <v-container class="full">
    <v-layout justify-center row>
      <v-flex class="top" lg10 md10 sm10 sx12>
        <v-flex class="top" lg10 md10 sm12 sx12>
          <v-layout justify-center>
            <v-flex class="pull" lg6 md6 sm12 sx12>
              <h1 class="h1">Proceso de Autoevaluación Institucional</h1>
            </v-flex>
            <v-flex class="line" lg1 md1 sm1 sx1 hidden-sm-and-down></v-flex>
            <v-layout align-center hidden-sm-and-down>
              <v-flex lg6 md6 sm3 sx12>
                <h2>Universidad de Santiago</h2>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="line2" lg4 md4 sm12 sx12 hidden-md-and-up>
        <h4>Universidad de Santiago</h4>
      </v-flex>
    </v-layout>
    <br />
<!--     <v-layout>
      <v-flex lg10 md10 sm12 sx12>
        <video controls id="myVideo">
          <source :src="video1" type="video/mp4" />
        </video>
      </v-flex>
    </v-layout> -->
  </v-container>
</template>

<script>
import video1 from "../../assets/general.mp4";
export default {
  data() {
    return {
      video1: video1,
      type: ""
    };
  },

  created() {
    this.type = this.$session.getAll().name;
  },

  methods: {
    pauseVideo() {
      document.getElementById("myVideo").pause();
      this.video = false;
    }
  }
};
</script>

<style scoped>
#myVideo {
  width: 100%;
  height: auto;
  margin-bottom: 50px;
}

.v-card {
  margin-bottom: 1%;
  padding-right: 3%;
  padding-left: 3%;
  padding-top: 0.5%;
  border: none !important;
}

.top {
  margin-top: 50px;
}

.bot {
  margin-bottom: 50px;
}

.h1 {
  font-size: 45px !important;
  color: grey !important;
}

.pull {
  text-align: left;
}

.line {
  border-right: 5px solid #4376a2;
}

.line2 {
  border-top: 5px solid #4376a2 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/inicio/IntroDCA.vue